<template>
  <item-base
    :route-name="routeName"
    icon="arrow-repeat"
  >
    データの初期化
  </item-base>
</template>

<script>
import ItemBase from './Base'

export default {
  components: {
    ItemBase
  },

  data () {
    return {
      routeName: 'data-init'
    }
  }
}
</script>
